import { Vector } from '../Vector';
import { Rotation } from './Rotation';
export class Scale {
    constructor(scaleX = 1, scaleY = 1) {
        this.type = 'Scale';
        this.assertIsPositive(scaleX);
        this.assertIsPositive(scaleY);
        this._scaleX = scaleX;
        this._scaleY = scaleY;
    }
    get scaleX() {
        return this._scaleX;
    }
    get scaleY() {
        return this._scaleY;
    }
    set scaleX(scaleX) {
        this.assertIsPositive(scaleX);
        this._scaleX = scaleX;
    }
    set scaleY(scaleY) {
        this.assertIsPositive(scaleY);
        this._scaleY = scaleY;
    }
    multiply(operand) {
        this.scaleX *= operand;
        this.scaleY *= operand;
        return this;
    }
    pow(operand) {
        let _a, _b;
        (_a = this).scaleX = Math.pow(_a.scaleX, operand);
        (_b = this).scaleY = Math.pow(_b.scaleY, operand);
        return this;
    }
    static calculateScale(arrivalPoint, handle, el, horizontalOffset, engine) {
        if (handle.relativePos.namePosition.length != 2) {
            throw new Error('handle is not a scale command');
        }
        arrivalPoint.x -= horizontalOffset;
        const vec1 = Vector.fromPos(el.center, arrivalPoint);
        const vec2 = Vector.fromPos(el.center, handle.pos); //relativePos.getPosition(el));
        const vec3 = vec1.projectOn(vec2);
        arrivalPoint = el.center.clone().applyVector(vec3);
        arrivalPoint = Rotation.rotatePoint(-el.angle, arrivalPoint, el.center);
        /*
                DebugTools.drawVector(el.center, vec1, 'black');
                DebugTools.drawVector(el.center, vec2, 'green');
                DebugTools.drawVector(el.center, vec3, 'purple');
                DebugTools.drawPosition(arrivalPoint, 3, 'red');
        */
        // multiply by 2 because compare from center
        let scaleY = (Math.abs(arrivalPoint.y - el.center.y) / el.originSize.height) * 2;
        let scaleX = (Math.abs(arrivalPoint.x - el.center.x) / el.originSize.width) * 2;
        if (handle.relativePos.namePosition.includes('m')) {
            if (handle.relativePos.namePosition.includes('l') || handle.relativePos.namePosition.includes('r')) {
                scaleY = el.scale.scaleY;
            } else {
                scaleX = el.scale.scaleX;
            }
        }
        try {
            return new Scale(scaleX, scaleY);
        } catch (e) {
            return new Scale(NaN, NaN);
        }
    }
    assertIsPositive(value) {
        if (value < 0) {
            throw new Error('Scale cannot be negative : ' + value);
        }
    }
    clone() {
        return new Scale(this._scaleX, this._scaleY);
    }
    static hydrate(data) {
        return new Scale(data._scaleX, data._scaleY);
    }
}
